<h5><fa-icon [icon]="['fas','lock']"></fa-icon>  Change Password</h5>
<form [formGroup]="changePasswordForm">
	<div class="row">
		<div class="col-md-{{12/columns}}">
			<div class="col-form-label">Old password</div>
			<div>
				<input type="password" class="form-control" formControlName="oldPassword" [readOnly]="readonlyState['oldPassword']">
			</div>
			<div class="error text-danger" *ngIf="changePasswordForm.controls.oldPassword.invalid">
				Your need to fill your old password
			</div>
		</div>
		<div class="col-md-{{12/columns}}">
			<div class="col-form-label">New password</div>
			<div>
				<input type="password" class="form-control" formControlName="newPassword"
					   [readOnly]="readonlyState['newPassword']" [autoClose]="false" triggers="focus"
					   [ngbPopover]="passwordValidationBody"
					   [popoverTitle]="passwordValidationTitle" placement="left">
			</div>
			<div class="error text-danger" *ngIf="changePasswordForm.controls.newPassword.invalid && changePasswordForm.controls['newPassword'].dirty">
				Your need to fill your new password or leave it blank if you dont want to change
			</div>
		</div>
		<div class="col-md-{{12/columns}}">
			<div class="col-form-label">Confirm new password</div>
			<div>
				<input type="password" class="form-control" formControlName="validatePassword" [readOnly]="readonlyState['validatePassword']">
			</div>
			<div class="error text-danger" *ngIf="changePasswordForm.controls['validatePassword'].value !== changePasswordForm.controls['newPassword'].value && changePasswordForm.controls['validatePassword'].dirty">
				Confirm password and new password must be identical or leave it blank if you dont want to change
			</div>
		</div>
	</div>
</form>
<ng-template #passwordValidationTitle><b class="validationTitle">Password Must</b></ng-template>
<ng-template #passwordValidationBody>
	<ul class="validationRequirements">
		<li [ngClass]="changePasswordForm.controls['newPassword'].hasError('required') ||
    changePasswordForm.controls['newPassword'].hasError('hasSmallCase') ? 'text-danger' : 'text-success'">
			<fa-icon [icon]="['fas','lock']"></fa-icon>
			<fa-icon [icon]="['fas','unlock']"></fa-icon>
			<span>Contain one lower case letter</span>
		</li>
		<li [ngClass]="changePasswordForm.controls['newPassword'].hasError('required') ||
    changePasswordForm.controls['newPassword'].hasError('hasCapitalCase') ? 'text-danger' : 'text-success'">
			<fa-icon [icon]="['fas','lock']"></fa-icon>
			<fa-icon [icon]="['fas','unlock']"></fa-icon>
			<span>Contain one upper case letter</span>
		</li>
		<li [ngClass]="changePasswordForm.controls['newPassword'].hasError('required') ||
    changePasswordForm.controls['newPassword'].hasError('hasNumber') ? 'text-danger' : 'text-success'">
			<fa-icon [icon]="['fas','lock']"></fa-icon>
			<fa-icon [icon]="['fas','unlock']"></fa-icon>
			<span>Contain one digit</span>
		</li>
		<li [ngClass]="changePasswordForm.controls['newPassword'].hasError('required') ||
    changePasswordForm.controls['newPassword'].hasError('minlength') ||
    changePasswordForm.controls['newPassword'].hasError('maxlength')  ? 'text-danger' : 'text-success'">
			<fa-icon [icon]="['fas','lock']"></fa-icon>
			<fa-icon [icon]="['fas','unlock']"></fa-icon>
			<span>Be 6-13 length</span>
		<li [ngClass]="changePasswordForm.controls['newPassword'].hasError('required') ||
    changePasswordForm.controls['newPassword'].hasError('hasSpace') ? 'text-danger' : 'text-success'">
		<fa-icon [icon]="['fas','lock']"></fa-icon>
		<fa-icon [icon]="['fas','unlock']"></fa-icon>
			<span>Has no spaces</span>
		</li>
	</ul>
</ng-template>